import { render } from "./faqs-component.vue?vue&type=template&id=aa8e573a"
import script from "./faqs-component.vue?vue&type=script&lang=js"
export * from "./faqs-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__